import type { ColorPalette } from '@/features/colors/color.types';
import {
  NEUTRAL_COOL,
  NEUTRAL_GRAY,
  NEUTRAL_WARM,
} from '@/features/colors/neutrals';

// Slots in design's column order: pink, orange, yellow, tan, green, blue,
// purple, gray — note tan is color6, not color3. Shades by role: 500 primary
// accent, 300 muted, 100 light category, 50 shaded cell.
//
// Like the other sheet palettes, Plum's sheet omits the warm/cool row, so the
// tie follows joyful's convention for the same eight columns.
//
// Several of Plum's accents are hexes Royal already ships (#8E1F5B, #A8451C,
// #1C4E7C) in different slots — see the note in palettes.ts.
export const plumPalette: ColorPalette = {
  id: 'plum',
  name: 'Plum',
  description: 'Deep & rich',
  requiresPaidPlan: true,
  colors: {
    cool: { ...NEUTRAL_COOL },
    gray: { ...NEUTRAL_GRAY },
    warm: { ...NEUTRAL_WARM },
    color0: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEEF5',
        '100': '#EFDCE7',
        '300': '#C184A5',
        '500': '#8E1F5B',
      },
    },
    color1: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEFEA',
        '100': '#F7E1D0',
        '300': '#CF9982',
        '500': '#A8451C',
      },
    },
    color2: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F8F3E6',
        '100': '#F6F1D2',
        '300': '#E0CB90',
        '500': '#C6A036',
      },
    },
    color3: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EDF6F1',
        '100': '#DCE8E2',
        '300': '#7EA597',
        '500': '#145C42',
      },
    },
    color4: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EDF4FC',
        '100': '#DDE4EC',
        '300': '#829EB7',
        '500': '#1C4E7C',
      },
    },
    color5: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F5F1FF',
        '100': '#EAE1F4',
        '300': '#A38FC3',
        '500': '#573391',
      },
    },
    color6: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F8F2ED',
        '100': '#EBE2D0',
        '300': '#AF9D89',
        '500': '#6E4C28',
      },
    },
    color7: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#C9C8CA',
        '100': '#E7E5E2',
        '300': '#8A8A8A',
        '500': '#4B4A50',
      },
    },
  },
};
